(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.weaver_calculation_fields = {

    addTableDivs: function(calculationParagraph) {
      const cells = calculationParagraph.querySelectorAll('th, td');
      if (cells.length < 1) {
        return;
      }

      cells.forEach((cell) => {
        if (cell.classList.contains('title') == false) {
          let div = document.createElement('div');
          div.textContent = cell.innerText;
          cell.replaceChildren(div);
        }
      });
    },

    calculateResultFromFields: function(calculationFormula, calculationFields) {
      let result = 0;

      const calculationFieldValues = this.getCalculationFieldValues(calculationFields);

      const isValueMissing = this.checkIfValuesExist(calculationFieldValues);
      
      if (isValueMissing == false) {
        result = math.evaluate(calculationFormula, calculationFieldValues);
        return Number(result).toFixed(2);
      }
    },

    checkEverythingValid: function(calculationParagraph) {
      // check all fields valid by checking if any single one is invalid
      const falseInputElement = calculationParagraph.querySelector('input[data-ptb-valid="false"]');
      if (falseInputElement == null) {
        return true;
      }

      return false;
    },

    checkIfValuesExist: function(calculationFieldValues) {
      const isValueMissing = Object.values(calculationFieldValues).some(v =>
        v === '' ||
        v == null ||
        (typeof v === 'string' && v.trim() === '')
      );
      return isValueMissing;
    },

    checkMinMax: function(inputObject, regionValue, calculationParagraph) {
      this.removeAllCellHighlights(calculationParagraph, inputObject.name);
      this.removeMessages(calculationParagraph, inputObject.name);

      const value = parseFloat(inputObject.value);

      if (
        isNaN(value) ||
        value == null
      ) {
        return;
      }

      const minValue = this.getMinOrMaxValue(calculationParagraph, regionValue, inputObject.name);
      const maxValue = this.getMinOrMaxValue(calculationParagraph, regionValue, inputObject.name, 'max');

      let isMinValid = false;
      let isMaxValid = false;

      if (
        minValue != null &&
        !isNaN(minValue) &&
        value >= minValue
      ) {
        isMinValid = true;
      }
      this.highlightCell(calculationParagraph, regionValue, inputObject.name, isMinValid);

      if (
        maxValue != null &&
        !isNaN(maxValue) &&
        value <= maxValue
      ) {
        isMaxValid = true;
      }

      this.highlightCell(calculationParagraph, regionValue, inputObject.name, isMaxValid, 'max');

      const minMaxValid = isMinValid == true && isMaxValid == true ? true : false;
      this.highlightInput(inputObject.element, minMaxValid);
      this.updateMessage(calculationParagraph, regionValue, inputObject.name, minMaxValid);

      const everythingValid = this.checkEverythingValid(calculationParagraph);
      this.updateResult(calculationParagraph, everythingValid);
    },

    dehighlightAllRegionTables: function(calculationParagraph) {
      const regionTables = calculationParagraph.querySelectorAll('table');
      if (regionTables.length < 1) {
        return;
      }

      regionTables.forEach((regionTable) => {
        regionTable.dataset.ptbActive = false;
      });
    },

    dehighlightInput: function(inputElement) {
      inputElement.dataset.ptbValid = null;
    },

    getCalculationFieldValues: function(calculationFields) {
      let calculationFieldValues = {};
      calculationFields.forEach((calculationField) => {
        let fieldname = calculationField.name;
        calculationFieldValues[fieldname] = calculationField.value ? parseFloat(calculationField.value.trim()) : null;
      });

      return calculationFieldValues;
    },

    getMinOrMaxValue: function(calculationParagraph, regionValue, type, minOrMax='min') {
      let value = 0;
      const regionTable = calculationParagraph.querySelector('#' + regionValue);

      if (regionTable == null) {
        return;
      }

      const row = regionTable.querySelector('tr[data-ptb-row="' + type + '"]');

      if (row == null) {
        return;
      }

      const cell = row.querySelector('td[data-ptb-cell="' + minOrMax + '"]');
      if (cell ==  null) {
        return;
      }

      value = parseFloat(cell.innerText.replace(/[^0-9.-]+/g, ""));
      return value;
    },

    getRegionValueCell: function(calculationParagraph, regionValue, type, minOrMax='min') {
      const regionTable = calculationParagraph.querySelector('#' + regionValue);
      if (regionTable == null) {
        return;
      }

      const cell = regionTable.querySelector('tr[data-ptb-row="' + type + '"] [data-ptb-cell="' + minOrMax + '"]');
      return cell;
    },

    highlightCell: function(calculationParagraph, regionValue, type, highlightType='valid', minOrMax='min') {

      const cell = this.getRegionValueCell(calculationParagraph, regionValue, type, minOrMax);

      if (cell == null) {
        return;
      }

      let validClass = 'valid';
      if (highlightType == false) {
        validClass = 'invalid';
      }

      cell.classList.add(validClass);
    },

    highlightInput: function(inputElement, minMaxValid) {
      inputElement.dataset.ptbValid = minMaxValid;
    },

    highlightRegionTable: function(calculationParagraph, regionValue) {
      this.dehighlightAllRegionTables(calculationParagraph);

      const regionTable = calculationParagraph.querySelector('#' + regionValue);
      if (regionTable == null) {
        return;
      }

      regionTable.dataset.ptbActive = true;

      // test scrolling on full-width pages only
      const fullWidthPage = document.querySelector('.ptb-fullwidth-page');
      if (fullWidthPage != null) {
        regionTable.scrollIntoView();
      }
    },

    initCalculation: function(calculationParagraph) {
      this.addTableDivs(calculationParagraph);
      
      const calculation = this.getCalculation(calculationParagraph);

      const resultSpan = calculationParagraph.querySelector('span.ptb-calculation-result');

      if (
        calculation == null ||
        resultSpan == null
      ) {
        return;
      }

      const calculationFields = this.getCalculationFields(calculationParagraph);
      if (calculationFields.length < 1) {
        return;
      }
  
      let result;
      calculationFields.forEach((calculationField) => {
        calculationField.addEventListener('input', () => {
          result = this.calculateResultFromFields(calculation.value, calculationFields);
          resultSpan.textContent = result;
        });
      });
    },

    getCalculation: function(calculationParagraph) {
      const calculation = calculationParagraph.querySelector('input[name="ptb-calculation"]');
      return calculation;
    },

    getCalculationFields: function(calculationParagraph) {
      const calculationFields = calculationParagraph.querySelectorAll('.ptb-calculation-html input');
      return calculationFields;
    },

    doCalculation: function() {
    },

    initCalculations: function() {
      const calculationParagraphs = document.querySelectorAll('.paragraph--type--ptb-calculation-fields');
      if (calculationParagraphs.length < 1) {
        return;
      }

      calculationParagraphs.forEach((calculationParagraph) => {
        this.initCalculation(calculationParagraph);
      });
    },

    /**
     * This function designed for rate band calculations specifically and does the following:
     * - highlights the selected region in the table (works on one region for now until others are added)
     * - checks if the flag rate entered in Flag Rate field is within range of their region's values
     * - checks if result of calculation is within range of their region's 5km trip fare values
     */
    initRateBandCalculations: function() {
      // use the field_ptb_calculation_id class as way to check if this calculation is being done
      const calculationParagraphs = document.querySelectorAll('.paragraph--type--ptb-calculation-fields');
      if (calculationParagraphs.length < 1) {
        return;
      }

      calculationParagraphs.forEach((calculationParagraph) => {

        const regionSelect = calculationParagraph.querySelector('select[name="ptbRegions"]');
        let regionValue = regionSelect.value;
        
        this.highlightRegionTable(calculationParagraph, regionValue);

        const ptbFlagInput = calculationParagraph.querySelector('input[name="ptbFlag"]');
        const ptbDistanceInput = calculationParagraph.querySelector('input[name="ptbDistance"]');

        if (
          regionValue == null ||
          ptbFlagInput == null ||
          ptbDistanceInput == null
        ) {
          console.log('Field is missing');
          return;
        }

  
     let valueElements = [
        {
          name: 'ptbFlag',
          element: ptbFlagInput
        },
        {
          name: 'ptbDistance',
          element: ptbDistanceInput
        }
      ];

      valueElements.forEach((valueElement) => {
          valueElement.element.addEventListener('input', () => {

            if (
              ptbFlagInput.value == '' &&
              ptbDistanceInput.value == ''
            ) {
              valueElements.forEach((valueElement) => {
                this.updateResult(calculationParagraph, null);
                this.dehighlightInput(valueElement.element);
                this.removeAllCellHighlights(calculationParagraph, valueElement.name);
                this.removeMessages(calculationParagraph, valueElement.name);
              });

            } else {
            
              valueElement.value = valueElement.element.value;
            
              if (valueElement.name == 'ptbDistance') {
                const calculation = this.getCalculation(calculationParagraph);
                const calculationFields = this.getCalculationFields(calculationParagraph);
                valueElement.value = this.calculateResultFromFields(calculation.value, calculationFields);
              }
              
              regionValue = regionSelect.value;
          
              this.checkMinMax(valueElement, regionValue, calculationParagraph);
            }
          });
        });

        regionSelect.addEventListener('change', (e) => {
          this.highlightRegionTable(calculationParagraph, regionSelect.value);

          valueElements.forEach((valueElement) => {
            this.checkMinMax(valueElement, regionSelect.value, calculationParagraph);
          });
        });
      });
    },

    removeMessages: function(calculationParagraph, type) {
      const messages = calculationParagraph.querySelectorAll('[data-ptb-type="' + type + '"]');
      if (messages.length < 1) {
        return;
      }

      messages.forEach((message) => {
        message.dataset.ptbActive = false;
      });
    },

    removeAllCellHighlights: function(calculationParagraph, type) {
      const cells = calculationParagraph.querySelectorAll('tr[data-ptb-row="' + type + '"] td');

      if (cells.length < 1) {
        return;
      }

      cells.forEach((cell) => {
        cell.classList.remove('valid');
        cell.classList.remove('invalid');
      });
    },

    updateMessage: function(calculationParagraph, regionValue, type, minMaxValid) {
      const messages = calculationParagraph.querySelectorAll('[data-ptb-type="' + type + '"]');
      if (messages.length < 1) {
        return;
      }

      messages.forEach((message) => {
        let messageValid = message.dataset.ptbValid === 'true'; //converts to real boolean
        if (messageValid == minMaxValid) {
          message.dataset.ptbActive = 'true';
        } 
      });
    },

    updateResult: function(calculationParagraph, everythingValid) {
      const resultElement = calculationParagraph.querySelector('.ptb-calculation-result-text');
      if (resultElement == null) {
        return;
      }

      resultElement.dataset.ptbValid = everythingValid;
    },

    attach: function (context, settings) {

      $(once('weaver_calculation_fields', 'body', context)).each(function () {
        const weaver_calculation_fields = Drupal.behaviors.weaver_calculation_fields;

        weaver_calculation_fields.initCalculations();
        weaver_calculation_fields.initRateBandCalculations();
      });
    }
  };
})(jQuery, Drupal, once);